import Model from './Model';

export default class AffiliateBonus extends Model {
  // eslint-disable-next-line class-methods-use-this
  resource() {
    return 'affiliate-bonuses';
  }
}
